import { constants as config } from '@config';
import searchOptionsTemplate from '../components/common/filter-search-options.hbs';
import BaseView from '../components/common/stock-component';
import StickerThumbnailView from '../components/thumbnail/sticker';
import SearchView from '../search/search';

module.exports = BaseView.extend({
  CategoriesView: require('./stickers'),

  initialize: function (opts) {
    opts = opts || {};

    BaseView.prototype.initialize.call(this, opts);
  },

  selectSearchOptionEvent: function (event) {
    const $target = $(event.currentTarget);
    const $options = this.$searchOptions.find('> div');

    if ($target.is($options)) {
      $options.removeClass('selected');
      $options.find('.desygner-icon-check').prependTo($target);
      $target.addClass('selected');
    }

    $options.closest('.search-container').children('input').focus();
  },

  search: function ($searchInput) {
    this.addedThumbnails = [];
    const $imageList = this.$el.find('.image-list');
    const $thumbnailWrapper = $imageList.find('.thumbnail-wrapper');

    $thumbnailWrapper.removeClass('thumbnail-wrapper').addClass('tab-content');
    $thumbnailWrapper.empty().css('height', '');

    this.$el.find('.categories-container').addClass('hidden');
    this.$el.find('.search-title').removeClass('hidden');
    this.$el.parent().find('.search-options').hide();
    $imageList.find('.antiscroll-scrollbar').remove();
    $imageList.find('.tab-content').empty().removeData();

    const val = $searchInput ? $searchInput.val() : '';
    const query = val || this.getRandomSearchValue();
    INKIVE.Modal.loader(this.$el.find('.antiscroll-inner').css('height', ''));

    this.initMasonry();
    this.searchView = this.searchView || new SearchView();
    this.searchView.initSearch($imageList, {
      query,
      type: 'icon',
      callback: this.refreshAntiscroll
    });
  },

  loadButtons: function () {
    const deferred = $.Deferred();

    INKIVE.Tool.preloadStickerCategories(function () {
      const data = INKIVE.Tool._cache.stickerCategories;

      deferred.resolve(_.map(data, function (stickersCategory) {
        return {
          key: stickersCategory.id,
          tag: stickersCategory.name
        };
      }));
    });

    return deferred.promise();
  },

  getSearchOptions: function (providers, types) {
    if (!this.$searchOptions) {
      this.$searchOptions = $(searchOptionsTemplate({
        isPremium: this.canUseFilters,
        providers,
        types,
        type: 'icons-' + this.$el.siblings('.header-links').find('.active').attr('data-key')
      }));

      INKIVE.Helpers.initPopover(this.$searchOptions);
    }

    return this.$searchOptions;
  },

  mapResult: function (item) {
    return {
      name: item.data.name,
      thumb_src: item.data.url,
      licence: item.data.licence,
      sticker_id: item.data.id,
      svg_url: item.data.svg_url
    };
  },

  addThumbnail: function (item) {
    if (_.contains(this.addedThumbnails, item.thumb_src)) {
      return;
    }

    this.addedThumbnails.push(item.thumb_src);

    const $view = $('<div class="thumbnail sticker">');
    const thumbnailView = new StickerThumbnailView({
      el: $view,
      item
    });

    thumbnailView.on('resize', _.bind(function (el) {
      this.$el.find('.thumbnail.sticker.details').each(function () {
        this === el || $(this).removeClass('details');
      });

      INKIVE.Helpers.afterRendering(_.bind(this.masonryReload, this));
    }, this));

    this.$el.find('.thumbnail-wrapper')
      .append($view)
      .masonry('appended', $view);

    thumbnailView.on('loaded', _.bind(this.masonryReload, this));

    return thumbnailView;
  },

  initMasonry: function () {
    this.$el.find('.image-list .thumbnail-wrapper').masonry(config.sidebar.thumbnail.masonryConfig);
  },

  masonryReload: function () {
    this.$el.find('.image-list .thumbnail-wrapper').masonry('layout');
  }
});
